class PixelAnalytics {
	constructor() {
	}

	listenToCustomTrackingEvents() {
		this.trackContactUsClicks();
		this.trackStoreLocatorEvents();
		this.trackBlogCategoryClicks();
		this.trackNewsletterSubscriptions();
		this.trackBrochureDownloadClicks();
		this.trackFaqClicks();
		this.trackLanguageChange();
		this.trackReviewClicks();
	}

	trackContactUsClicks() {
		const GORGIAS_URL = 'kusmitea-ssw4lt8dynr.gorgias.help';

		document.addEventListener('click', (event) => {
			const link = event.target.closest('a[href]');
			if (!link) return;

			if (link.href.includes(GORGIAS_URL)) {
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					event: 'click_contact_us_ta'
				});
			}
		});
	}

	trackStoreLocatorEvents() {
		// Events sur les liens avec data-gtm-event (phone, itinerary, more info)
		// 17 - store_locator_localization_ta
		// 19 - store_locator_click_phone_ta
		// 21 - store_locator_click_more_information_ta
		// Phase de capture (true) pour intercepter avant le stopPropagation du store locator
		// Restreint aux éléments interactifs (a, button) pour éviter les faux positifs sur les divs conteneurs
		document.addEventListener('click', (event) => {
			const el = event.target.closest('a[data-gtm-event], button[data-gtm-event]');
			if (!el) return;

			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: el.dataset.gtmEvent,
				store_city: el.dataset.gtmStoreCity || '',
				store_postal_code: el.dataset.gtmStoreZip || ''
			});
		}, true);

		// 16 - store_locator_search_ta : dispatché depuis le JS du store locator
		document.addEventListener('storelocator:search', (event) => {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: 'store_locator_search_ta',
				store_city: event.detail.city || '',
				store_postal_code: event.detail.zip || ''
			});
		});

		// 18 - store_locator_click_map_ta : dispatché depuis le listener marker Google Maps
		document.addEventListener('storelocator:mapclick', (event) => {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: 'store_locator_click_map_ta',
				store_city: event.detail.city || '',
				store_postal_code: event.detail.zip || ''
			});
		});
	}
	trackNewsletterSubscriptions() {
		document.addEventListener('submit', (event) => {
			const wrapper = event.target.closest('[data-gtm-event="subscribe_newsletter_ta"]');
			if (!wrapper) return;

			const emailInput = event.target.querySelector('input[type="email"]');

			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: 'subscribe_newsletter_ta',
				location: wrapper.dataset.gtmLocation,
				user_data: {
					email_address: emailInput ? emailInput.value : ''
				}
			});
		});
	}

	trackBrochureDownloadClicks() {
		document.addEventListener('click', (event) => {
			const link = event.target.closest('a[data-gtm-brochure]');
			if (!link) return;

			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: 'click_brochure_ta',
				brochure_name: link.dataset.gtmBrochure
			});
		});
	}

	trackFaqClicks() {
		document.addEventListener('click', (event) => {
			const summary = event.target.closest('.faq summary');
			if (!summary) return;

			const questionSpan = summary.querySelector('span');
			const faqAction = questionSpan ? questionSpan.textContent.trim() : '';

			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: 'click_faq_ta',
				faq_action: faqAction
			});
		});
	}

	trackLanguageChange() {
		// Orbe fait une navigation directe (window.location), pas de form submit ni fetch.
		// On intercepte le clic sur le bouton "Shop now" du modal Orbe.
		document.addEventListener('click', (event) => {
			const btn = event.target.closest('#md-app-embed__modal .md-btn__primary');
			if (!btn) return;

			const languageInput = document.querySelector('#orbe-lang-selector-popup-id');
			if (!languageInput || !languageInput.value) return;

			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: 'click_change_language_ta',
				language: languageInput.value.toUpperCase()
			});
		});
	}

	trackReviewClicks() {
		document.addEventListener('click', (event) => {
			const stars = event.target.closest('.skeepers_product__stars');
			if (!stars) return;

			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: 'click_review_ta'
			});
		});
	}

	trackBlogCategoryClicks() {
		document.addEventListener('click', (event) => {
			const tag = event.target.closest('[data-gtm-event="click_category_blog_ta"]');
			if (!tag) return;

			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: 'click_category_blog_ta',
				blog_category_name: tag.dataset.gtmBlogCategory
			});
		});
	}
}

const pixelAnalytics = new PixelAnalytics();
pixelAnalytics.listenToCustomTrackingEvents();
